function CategoriesController ( CityConfigService )
{
    "ngInject";

    var vm = this;
        vm.cityConfig = CityConfigService;
}

module.exports = CategoriesController;